import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialIconType } from '../../enums/social-icon-type';
import { Icon } from '../../../icon/enums/icon';
import { IconComponent } from '../../../icon/components/icon/icon.component';

@Component({
  selector: 'app-social-icon',
  imports: [CommonModule, IconComponent],
  templateUrl: './social-icon.component.html',
  styleUrl: './social-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialIconComponent {
  public readonly type = input.required<SocialIconType>();

  protected readonly cssClass = this.buildCssClassSignal();
  protected readonly icon = this.buildIconSignal();

  private buildCssClassSignal(): Signal<string> {
    return computed((): string => {
      switch (this.type()) {
        case SocialIconType.Facebook:
          return 'bg-[#3b5998] border-[#3b5998] hover:text-[#3b5998]';

        case SocialIconType.Google:
          return 'bg-[#cc3333] border-[#cc3333] hover:text-[#cc3333]';
      }
    });
  }

  private buildIconSignal(): Signal<Icon> {
    return computed((): Icon => {
      switch (this.type()) {
        case SocialIconType.Facebook:
          return Icon.Facebook;

        case SocialIconType.Google:
          return Icon.Google;
      }
    });
  }
}
